import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "features/baseQuery";

interface Backup {
  name: string;
  size: number;
  sizeFormatted: string;
  date: string;
}

export const backupsSlice = createApi({
  reducerPath: "backupsApi",
  baseQuery: baseQueryWithAuth("backups"),
  tagTypes: ["Backups"],
  endpoints: (builder) => ({
    fetchBackups: builder.query<Backup[], void>({
      query: () => "/",
      providesTags: ["Backups"],
    }),
    createBackup: builder.mutation<{ success: boolean; message: string; backup: Backup }, { label?: string }>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Backups"],
    }),
    deleteBackup: builder.mutation<{ success: boolean; message: string }, string>({
      query: (name) => ({
        url: `/${name}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Backups"],
    }),
  }),
});

export const {
  useFetchBackupsQuery,
  useCreateBackupMutation,
  useDeleteBackupMutation,
} = backupsSlice;
